import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageImages } from "@/v2/lib/usePageImages";

const ARTICLES = [
  { title: "How to Choose the Right Rug Size", cat: "Guides", read: "5 min read", img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=85" },
  { title: "Rug Placement Guides for Every Room", cat: "Guides", read: "7 min", img: "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1200&q=85" },
  { title: "Caring for a Hand-Tufted Rug", cat: "Craft", read: "4 min", img: "https://images.pexels.com/photos/29848182/pexels-photo-29848182.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Choosing Rugs for Homes with Children", cat: "Living", read: "6 min", img: "https://images.unsplash.com/photo-1610384104075-e05c8cf200c3?auto=format&fit=crop&w=1200&q=85" },
  { title: "Understanding Handmade Rug Techniques", cat: "Craft", read: "8 min", img: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?auto=format&fit=crop&w=1200&q=85" },
  { title: "Behind the Craft — A Day in Bhadohi", cat: "Behind the Craft", read: "10 min", img: "https://images.pexels.com/photos/37877827/pexels-photo-37877827.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Styling Small Spaces with Rugs", cat: "Living", read: "5 min", img: "https://images.unsplash.com/photo-1705326701287-346fc37a2c86?auto=format&fit=crop&w=1200&q=85" },
];

const CATS = ["All", "Guides", "Craft", "Living", "Behind the Craft"];

export default function V2Journal() {
  const { img } = usePageImages();
  return (
    <div data-testid="v2-journal-page">
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 pt-14 md:pt-20 pb-14 text-center">
        <div className="overline-v2">The Iryaa Journal</div>
        <h1 className="mt-5 font-serif-warm text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">Stories from Iryaa.</h1>
        <p className="mt-6 text-[16px] text-[#4a4640] font-light max-w-2xl mx-auto">
          Guidance, craft stories and small essays on living beautifully with handmade things.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {CATS.map((c) => (
            <button key={c} className={`px-4 py-2 text-[11px] uppercase tracking-[0.22em] border ${c === "All" ? "bg-[#1a1a1a] text-[#fbf9f5] border-[#1a1a1a]" : "border-[#c9c0ae] hover:border-[#1a1a1a]"}`}>{c}</button>
          ))}
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 pb-24">
        {/* Featured article */}
        <Link to="#" className="group block mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7 relative aspect-[16/10] overflow-hidden bg-[#f2ede2]">
              <img src={img("journal.0", ARTICLES[0].img)} alt="" className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
            </div>
            <div className="lg:col-span-5">
              <div className="overline-v2">{ARTICLES[0].cat} · {ARTICLES[0].read}</div>
              <h2 className="mt-4 font-serif-warm text-4xl md:text-5xl leading-[1.05]">{ARTICLES[0].title}</h2>
              <p className="mt-6 text-[15px] text-[#4a4640] font-light leading-relaxed max-w-lg">
                A pocket-sized guide to matching rug size to room size — with photographs, measurements and the one mistake almost everyone makes.
              </p>
              <div className="mt-8 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.24em] text-[#1a1a1a] v2-link pb-1">
                Read article <ArrowRight size={12} />
              </div>
            </div>
          </div>
        </Link>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
          {ARTICLES.slice(1).map((a, i) => (
            <Link key={a.title} to="#" className="group block">
              <div className="relative aspect-[4/5] overflow-hidden bg-[#f2ede2]">
                <img src={img(`journal.${i + 1}`, a.img)} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
              </div>
              <div className="mt-4">
                <div className="overline-v2 text-[10px]">{a.cat} · {a.read}</div>
                <div className="mt-2 font-serif-warm text-2xl leading-tight">{a.title}</div>
                <div className="mt-3 text-[11px] uppercase tracking-[0.22em] text-[#7a7466]">Read →</div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16 text-center text-[13px] text-[#7a7466] font-light italic">
          More stories coming soon. In the meantime, why not <Link to="/collections" className="v2-link text-[#1a1a1a]">browse the collection</Link>?
        </div>
      </section>
    </div>
  );
}
